import {SIGN_SERVICE} from "@/store/constants";

const SIGN_PREFIX = '/sign/'

export default {
  namespaced: true,
  state: {},
  actions: {
    getSignatoriesByContent ({ dispatch }, { id }) {
      return dispatch('API', SIGN_SERVICE, { root: true })
          .then(api => api.post(SIGN_PREFIX + "search", { content: encodeURIComponent(id) }))
          .then(result => (result.data))
    },
    saveSignatory ({ dispatch }, { id, data }) {
      if (id) {
        return dispatch('updateSignatory', { id, data })
      }
      return dispatch('addSignatory', { data })
    },
    addSignatory ({ dispatch }, data) {
      return dispatch('API', SIGN_SERVICE, { root: true })
          .then(api => api.post(SIGN_PREFIX, data))
          .then(result => (result.data))
    },
    updateSignatory ({ dispatch }, { id, data }) {
      return dispatch('API', SIGN_SERVICE, { root: true })
          .then(api => api.put(SIGN_PREFIX + encodeURIComponent(id), data))
          .then(result => (result.data))
    },
    deleteSignatory ({ dispatch }, { id }) {
      return dispatch('API', SIGN_SERVICE, { root: true })
          .then(api => api.delete(SIGN_PREFIX + encodeURIComponent(id)))
          .then(result => (result.data))
    },

    send ({ dispatch }, { id, message }) {
      return dispatch('API', SIGN_SERVICE, { root: true })
          .then(api => api.post(SIGN_PREFIX + encodeURIComponent(id) + '/send', { message }))
          .then(result => (result.data))
    },

    sendNext ({ dispatch }, { content, message }) {
      return dispatch('API', SIGN_SERVICE, { root: true })
          .then(api => api.post(SIGN_PREFIX + 'send/' + encodeURIComponent(content.id), { message }))
          .then(result => (result.data))
    },

    sign ({ dispatch }, { content, id }) {
      return dispatch('API', SIGN_SERVICE, { root: true })
          .then(api => api.post('/public' + SIGN_PREFIX + encodeURIComponent(id)))
          .then(result => (result.data))
    },
  },
  mutations: {},
  getters: {}
}
